module.exports = __webpack_public_path__ + "img/Xmas-banner.3746cc8d.png";